import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
export interface ModificationInfo {
  isModified: boolean;
}

@Injectable()
export class ComponentCodeService {

  constructor(
    private http: HttpClient) {
  }

  private baseUrl = '/api/dev/main/v1.0/codeeditor';
  private openCodeByIDEAUrl = `${this.baseUrl}/` + 'idea';
  private isFileModifiedUrl = `${this.baseUrl}/` + 'check';

  /**
   * è·åæä»¶ä»£ç 
   * @param filePath æä»¶ä»£ç æä»¶è·¯å¾ï¼ç¸å¯¹å·¥ä½ç©ºé´
   */
  public get(filePath: string): Observable<string> {
    const body = {
      fileName: filePath
    };
    return this.http.post(this.baseUrl, body, { responseType: 'text' });
  }

  public isFileModified(filePath: string): Observable<any> {
    const body = {
      fileName: filePath
    };
    return this.http.post(this.isFileModifiedUrl, body);
  }

  /**
   * ä¿å­æä»¶ä»£ç 
   * @param filePath æä»¶ä»£ç æä»¶è·¯å¾ï¼ç¸å¯¹å·¥ä½ç©ºé´
   * @param componentCode å¾ä¿å­ä»£ç 
   */
  public save(filePath: string, componentCode: string): Observable<any> {
    const body = {
      fileName: filePath,
      code: componentCode
    };
    return this.http.put(this.baseUrl, body);
  }

  /**
   * éè¿ideaæå¼æä»¶ä»£ç 
   * @param filePath æä»¶ä»£ç æä»¶è·¯å¾
   */
  public openCodeByIDEA(filePath: string): Observable<any> {
    const body = {
      fileName: filePath
    };
    return this.http.put(this.openCodeByIDEAUrl, body);
  }

  /**
   * è·åæä»¶ä»£ç æä»¶çç¸å¯¹å·¥ä½ç©ºé´è·¯å¾
   */
  public getCodeFilePath(metadataRetalivePath: string): Observable<any> {
    const requestParam = {
      metadataRelativePath: metadataRetalivePath,
    };
    return this.http.get(this.baseUrl, { params: requestParam, responseType: 'text' });
  }

}
